import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
export var getTranslationByName = function getTranslationByName(labels, language, fieldName) {
  var filteredObject = labels && labels.filter(function (label) {
    return language && label.key.localeCode.toLowerCase() === language.toLowerCase() && label.key.fieldName === fieldName;
  });
  return filteredObject;
};
export var getTranslationByValue = function getTranslationByValue(labels, language, fieldName) {
  var value = labels && getTranslationByName(labels, language, fieldName)[0] && getTranslationByName(labels, language, fieldName)[0].value;
  return value;
};
/* this function will give the output in this format.
  finalObj = {en: 'value1', 'fr': value2', 'zh_CN': 'value3'}
*/

export var getDynamicKeyValueForTranslation = function getDynamicKeyValueForTranslation(languagesList, translatedFields, value, key, isValueTypeObj) {
  var finalObj = {};
  languagesList && languagesList.forEach(function (language) {
    if (isValueTypeObj) {
      finalObj = _objectSpread({}, finalObj, _defineProperty({}, language.localeCode, value[language.localeCode]));
    } else if (language.localeCode === 'en') {
      finalObj = _objectSpread({}, finalObj, _defineProperty({}, language.localeCode, value));
    } else {
      finalObj = _objectSpread({}, finalObj, _defineProperty({}, language.localeCode, getTranslationByValue(translatedFields.labels, language.localeCode, key) || ''));
    }
  });
  return finalObj;
};
export default {};